import { render, staticRenderFns } from "./InvestorOnboardingLegalRepData.vue?vue&type=template&id=48281771&"
import script from "./InvestorOnboardingLegalRepData.vue?vue&type=script&lang=js&"
export * from "./InvestorOnboardingLegalRepData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports